import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewCaseApprovalService {
  routePrefix = '/api/newCasePreApproval';

  constructor(private http: HttpClient) { }

  getDiseases() : Observable<any> {
    return this.http.get(this.routePrefix +"/getDiseases");
  }
  getEnrol(groupPolicyId: number, certificateNumber: string, birthYear: string) : Observable<any> {
    return this.http.get(this.routePrefix +"/getEnrolInformations/" + groupPolicyId + "/" +certificateNumber + "/" + birthYear);
  }
  getEnrolInformation(enrolId: number) : Observable<any> {
    return this.http.get(this.routePrefix +"/getInformations/" + enrolId);
  }
  searchPolicy(pattern: string) : Observable<any> {
    return this.http.get(this.routePrefix +"/gets/SearchGroupPolicy/" + pattern);
  }
  runEligibility(data): Observable<any>{
    return this.http.post(this.routePrefix + "/runEligibility", data);
  }

  generatePreApprovalLetter = (ppoRequestId: number) => {
    return this.http.get(`${ this.routePrefix }/generatePreApprovalLetter/${ ppoRequestId }`,
     { responseType: 'blob' }).pipe(map((result: any) => {
      return result;
    }));
  }
}
